import Rest from "../../../class/tool/Rest";
import FormBuilder from "../../../class/tool/FormBuilder";
import StringTools from "../../../class/tool/StringTools";
import legalDataController from "./LegalDataController";
import RegexTools from "../../../class/tool/RegexTools";

class LegalDataController {
    _rest = new Rest();
    _callback = null;
    _baseURL = "stores/:idStore/legaldatas";
    _errors = {
        "socialReason": {
            "empty": "La raison sociale est obligatoire",
            "wrong": "La raison sociale doit être comprise entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        },
        "siret": {
            "empty": "Le numéro de SIRET est obligatoire",
            "wrong": "Le numéro de SIRET est invalide, il doit comporter 14 chiffres"
        },
        "ape": {
            "empty": "Le code APE (code NAF) est obligatoire",
            "wrong": "Le code APE (code NAF) est invalide, il doit comporter 4 chiffres + 1 lettre"
        },
        "tvaIntra": {
            "empty": "Le numéro de TVA intracommunautaire est obligatoire",
            "wrong": "Le numéro de SIRET est invalide"
        },
        "companyRegister": {
            "empty": "Le RCS est obligatoire",
            "wrong": "Le RCS est invalide"
        },
        "legalStatus": {
            "empty": "Le statut juridique est obligatoire",
            "wrong": "Le statut juridique est invalide"
        },
        "bankName": {
            "empty": "Le nom de la banque est obligatoire",
            "wrong": "Le nom de la banque est invalide"
        },
        "iban": {
            "empty": "Le numéro IBAN est obligatoire",
            "wrong": "Le numéro IBAN est invalide"
        },
        "bic": {
            "empty": "Le code BIC est obligatoire",
            "wrong": "Le code BIC est invalide"
        }
    };
	static _legalStatus = [
		"Indéfini",
		"EI",
		"EURL",
		"SARL",
		"SA",
		"SAS",
		"SNC",
		"SCOP"
	];
	static _bankNames = [
		"Banque Populaire",
		"Bred",
		"BNP Paribas",
		"Caisse d'Epargne",
		"CIC",
		"Crédit Agricole",
		"Crédit Coopératif",
		"Crédit du Nord",
		"Crédit Mutuel",
		"Groupama Banque",
		"La Banque Postale",
		"LCL",
		"Société Générale"
	];

    // perform
k
    setFormValues(object, setValues, formNew = false, datas) {
        if (formNew) {
            setValues(prev => ({
                ...prev,
                socialReason: "",
                siret: "",
                ape: "",
                tvaIntra: "",
                companyRegister: "",
                legalStatus: "",
                bankName: null,
                iban: "",
                bic: ""
            }));
        }
        else {
            setValues(prev => ({
                ...prev,
                socialReason: object.socialReason,
                siret: object.siret,
                ape: object.ape,
                tvaIntra: object.tvaIntra,
                companyRegister: object.companyRegister,
                legalStatus: object.legalStatus,
                bankName: object.bankName,
                iban: object.iban,
                bic: object.bic
            }));
        }
    }
    setFormRows(setRows, formNew = false, datas) {
        let rows;
		let legalStatus = [
			{
				value: "Choisir une statut",
				id: null
			},
			{
				value: "----------",
				id: null
			}
		];
		let bankNames = [
			{
				value: "Choisir une banque",
				id: null
			},
			{
				value: "----------",
				id: null
			}
		];

		for (let i in legalDataController._legalStatus) {
			legalStatus.push({
				value: legalDataController._legalStatus[i],
				id: i
			});
		}

		for (let i in legalDataController._bankNames) {
			bankNames.push({
				value: legalDataController._bankNames[i],
				id: i
			});
		}

        if (formNew) {
            rows = [
                {
                    label: "Raison sociale",
                    attribute: "socialReason",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Nom de société figurant sur le KBIS",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "SIRET",
                    attribute: "siret",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "XXX XXX XXX XXXXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "Code APE",
                    attribute: "ape",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "XX.XXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "TVA Intracommunautaire",
                    attribute: "tvaIntra",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "FRXX XXX XXX XXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "RCS",
                    attribute: "companyRegister",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "RCS",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
				{
					label: "Statut juridique",
					attribute: "legalStatus",
					inputType: "select",
					returnType: "string",
					list: legalStatus,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
				{
					label: "Banque",
					attribute: "bankName",
					inputType: "select",
					returnType: "string",
					list: bankNames,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
                {
                    label: "IBAN",
                    attribute: "iban",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "IBAN",
                    autoComplete: "off",
                    needed: false,
                    checkData: null
                },
                {
                    label: "BIC",
                    attribute: "bic",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Code BIC",
                    autoComplete: "off",
                    needed: false,
                    checkData: null
                }
            ];
        }
        else {
            rows = [
                {
                    label: "Raison sociale",
                    attribute: "socialReason",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Nom de société figurant sur le KBIS",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "SIRET",
                    attribute: "siret",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "XXX XXX XXX XXXXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "Code APE",
                    attribute: "ape",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "XX.XXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "TVA Intracommunautaire",
                    attribute: "tvaIntra",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "FRXX XXX XXX XXX",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
                {
                    label: "RCS",
                    attribute: "companyRegister",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "RCS",
                    autoComplete: "off",
                    needed: true,
                    checkData: null
                },
				{
					label: "Statut juridique",
					attribute: "legalStatus",
					inputType: "select",
					returnType: "string",
					list: legalStatus,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
				{
					label: "Banque",
					attribute: "bankName",
					inputType: "select",
					returnType: "string",
					list: bankNames,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
                {
                    label: "IBAN",
                    attribute: "iban",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "IBAN",
                    autoComplete: "off",
                    needed: false,
                    checkData: null
                },
                {
                    label: "BIC",
                    attribute: "bic",
                    inputType: "text",
                    returnType: "string",
                    classnameWrapper: null,
                    classnameLabel: null,
                    classnameInput: "",
                    placeholder: "Code BIC",
                    autoComplete: "off",
                    needed: false,
                    checkData: null
                }
            ];
        }

        setRows(rows);
    }
    returnPostDatas(datas) {
        let datasToPost = {};
        let needed = ["socialReason", "siret", "ape", "tvaIntra", "legalStatus", "companyRegister"];
        let optionals = ["bankName", "iban", "bic"];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnPutDatas(datas) {
        let datasToPost = {};
        let needed = ["socialReason", "siret", "ape", "tvaIntra", "legalStatus", "companyRegister"];
        let optionals = ["bankName", "iban", "bic"];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        return FormBuilder.returnUpdates(object, datas, compare)
    }

    hasValidMinimumDatas(values, type, subType = null) {
        let datas;
        let resultData;

        switch (type) {
            case "newLegalData":
                datas = this.returnPostDatas(values);

                for (let key in datas) {
                    resultData = this.checkDataToPost(key, datas[key]);

                    if (!resultData.result)
                        return false;
                }

                return true;
            case "updateLegalData":
                datas = this.returnPutDatas(values);

                for (let key in datas) {
                    resultData = this.checkDataToPost(key, datas[key]);

                    if (!resultData.result)
                        return false;
                }

                return true;
            default:
                return false;
        }
    }
	okToSend(datas, setEvent) {
		return true;
	}
    checkDataToPost(attribute, value) {
        switch (attribute) {
            case "socialReason": return this.controlSocialReason(value);
            case "siret": return this.controlSiret(value);
            case "ape": return this.controlApe(value);
            case "tvaIntra": return this.controlIntraTva(value);
            case "companyRegister": return this.controlCompanyRegister(value);
            case "legalStatus": return this.controlLegalStatus(value);
            case "bankName": return this.controlBankName(value);
            case "iban": return this.controlIban(value);
            case "bic": return this.controlBic(value);
            default:
                console.log("Unknown attribute", attribute);
                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
    controlSocialReason(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["socialReason"]["empty"]
            };
        }

        let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

        if (!regex.test(StringTools.removeAccents(value))) {
            return {
                result: false,
                error: this._errors["socialReason"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlSiret(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["siret"]["empty"]
            };
        }

        let regex = /^\d{14}$/i;

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["siret"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlApe(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["ape"]["empty"]
            };
        }

        let regex = /^(\d{4}[a-zA-Z]{1}|\d{2}[.]\d{2}[a-zA-Z]{1})$/g;

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["ape"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlIntraTva(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["tvaIntra"]["empty"]
            };
        }

        let regex = /^(ATU\d{8}|BE[01]\d{9}|BG\d{9,10}|CY\d{8}[LX]|CZ\d{8,10}|DE\d{9}|DK\d{8}|EE\d{9}|EL\d{9}|ES[\dA-Z]\d{7}[\dA-Z]|FI\d{8}|FR[\dA-Z]{2}\d{9}|HR\d{11}|HU\d{8}|IE\d{7}[A-Z]{2}|IT\d{11}|LT(\d{9}|\d{12})|LU\d{8}|LV\d{11}|MT\d{8}|NL\d{9}B\d{2}|PL\d{10}|PT\d{9}|RO\d{2,10}|SE\d{12}|SI\d{8}|SK\d{10})$/g

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["tvaIntra"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlLegalStatus(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["legalStatus"]["empty"]
            };
        }

		if (!LegalDataController._legalStatus.includes(value)) {
            return {
                result: false,
                error: this._errors["legalStatus"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlCompanyRegister(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["companyRegister"]["empty"]
            };
        }

        let regex = /^RCS \w+((\-?| ?)\w+)? [a-bA-B] (\d{9}|((\d{3} ){2}\d{3}))$/g

        if (!regex.test(value)) {
            return {
                result: false,
                error: this._errors["companyRegister"]["wrong"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlBankName(value) {
        if (value !== undefined && value !== null && value.length > 0) {
        	if (!legalDataController._bankNames.includes(value)) {
				return {
					result: false,
					error: this._errors["bankName"]["wrong"]
				};
			}
        }

        return {
            result: true,
            error: null
        };
    }
    controlIban(value) {
        if (value !== undefined && value !== null && value.length > 0) {
			let regex = RegexTools.getRegex("iban");

			if (!regex.test(value)) {
				return {
					result: false,
					error: this._errors["iban"]["wrong"]
				};
			}
        }

        return {
            result: true,
            error: null
        };
    }
    controlBic(value) {
        if (value !== undefined && value !== null && value.length > 0) {
            let regex = RegexTools.getRegex("bic");

			if (!regex.test(value)) {
				return {
					result: false,
					error: this._errors["bic"]["wrong"]
				};
			}
        }

        return {
            result: true,
            error: null
        };
    }

    // Controllers

    post(store, datas) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'POST',
            '/' + this._baseURL.replace(":idStore", store.id),
            datas,
            this.handlePost
        );
    }
    handlePost = (response, error, status) => {
        this._callback(response, error, status);
    }
    put(store, legalData, datas) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'PUT',
            '/' + this._baseURL.replace(":idStore", store.id) + '/' + legalData.id,
            datas,
            this.handlePut
        );
    }
    handlePut = (response, error, status) => {
        this._callback(response, error, status);
    }
}

export default LegalDataController;
